import {IonItem, IonCol, IonImg } from '@ionic/react';
import React, {useEffect} from 'react';

//const photos;


export const PhotoGallery = (
  props: { 
  photos: any, 
  setPhotos:any
   }) => {
    
  useEffect(() => {
    console.log(props.photos);
    console.log("photos updated");
  }, [props.photos]);

    return(
      
      <IonItem className="hidden">
         {props.photos.map((photo:any, index:any) => (
          <IonCol>
             <IonImg key={index} src={photo.webviewPath!} />
          </IonCol>
          ))} 
        </IonItem>
   
    )
}
export default PhotoGallery;